import { RootState } from '../../../../stores/store';

export const usersListSelector = (state: RootState) => state.userList;
